'use client'

import Header from '@/components/header/Header'
import React, { useEffect, useState } from 'react'
// import logoMain from '@/assets/img/logo-main.svg'
import MainOrder from '@/components/main/MainOrder'
import ForPartners from '@/components/ForPartners/ForPartners'
import NewsBanner from '@/components/news/NewsBanner'
import Link from 'next/link'
import UsefulMatSlider from '@/components/useful-materials/UsefulMatSlider'
import Footer from '@/components/Footer/Footer'
import orderItem from '@/assets/data/main-order.json'
import CategoriesSlider from '@/components/CategoriesSlider'
import MainSliderChapters from '@/components/main/MainSliderChapters'
import { useGetAllAnimalTypesQuery } from '@/redux/services/admin/animalTypesApi'
import { useGetAllMaterialsQuery } from '@/redux/services/materialsApi'
import { useDispatch } from 'react-redux'
import { setResetCatalogFilters, setResetMaterialsFilters, setResetNewsFilters } from '@/redux/features/filterSlice'
import MainSceneWithWrapper from '@/components/MainSceneWithWrapper/MainSceneWithWrapper'
import MainAbout from '@/components/main/MainAbout'
import CardSlider from '@/components/CardSlider'
import { useTranslation } from 'react-i18next'

const ProductsModule = () => {
    const [page, setPage] = useState(0)
    const [count, setCount] = useState(10)
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const headSliderList = [t('productionLower'), t('premixes'), t('combikorms'), t('individual_recipes')]

    const productsList = {
        // page: 'products',
        items: [
            {
                title: t('ProductsUpper'),
                text: [
                    t("megamix_group_of_companies_is_the_largest"),
                    t("you_can_order_wholesale_mixed")
                ],
                cardClass: 'product__slide'
            },
            {
                title: t("premixesUpper"),
                text: [
                    t('premix_is_a_concentrate_of_vitamins'),
                    t('the_introduction_of_premixes_into_animal_rations')
                ],
                cardClass: 'product__slide'
            },
            {
                title: t("combikormsUpper"),
                text: [
                    t('productivity_and_life_span_of_farm_animals'),
                    t('megamix_produces_from')
                ],
                cardClass: 'product__slide'
            },
            {
                title: t('individual_recipesUpper'),
                text: [
                    t('it_is_possible_to_produce_mixed_fodder'),
                    t('we_use_only_high_quality_raw_materials')
                ],
                cardClass: 'product__slide'
            }
        ],
        btn: {
            content: t('go_to_catalog'),
            link: '/catalog',
            icon: 'burger',
            isBlank: true
        }
    }

    const cardItem = {
        tag: t('card_tag_farmers'),
        title: t('megakorm'),
        text: [
            t('we_produce_mixtures'),
            t('the_composition_of_each_product_corresponds'),
            t('you_can_buy_MEGAKORM_mixed_fodder')
        ],
        btn: {
            content: t('toWebsiteButton'),
            link: 'https://megakorm.ru',
            icon: 'sphera'
        }
    }

    useEffect(() => {
        dispatch(setResetNewsFilters())
        dispatch(setResetMaterialsFilters())
        dispatch(setResetCatalogFilters())
    }, [])

    const { data: animalTypes } = useGetAllAnimalTypesQuery()
    const { data: allMaterials } = useGetAllMaterialsQuery({
        page: page,
        count: count
    })

    return (
        <main className='main'>
            {/* <div className="home__light-blue"></div>
            <div className="home__purple-1"></div>
            <div className="home__purple-2"></div>
            <div className="home__violet"></div> */}
            <Header burgerBg='linear-gradient(180deg, #3156A8 21.87%, #2D3079 108.55%)' />
            <MainSceneWithWrapper
                bottomBlur={true}
                zInx={-1}
            />
            <div className='main-products'>
                <div className='main-products__production container'>
                    <div>
                        <Link
                            href={'/#map-cards'}
                            style={{ position: 'relative', zIndex: 2, height: 'auto' }}
                        >
                            <button className='buttons buttons__maps'>
                                <svg
                                    width='19'
                                    height='19'
                                    viewBox='0 0 19 19'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <g opacity='0.6'>
                                        <path
                                            d='M1 3.34483L5.95833 1V15.6552L1 18V3.34483Z'
                                            stroke='#CBD9F9'
                                            strokeWidth='1.6'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                        />
                                        <path
                                            d='M12.3334 3.34483L18 1V15.6552L12.3334 18V3.34483Z'
                                            stroke='#CBD9F9'
                                            strokeWidth='1.6'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                        />
                                        <path
                                            d='M12.3334 3.34483L5.95837 1V15.6552L12.3334 18V3.34483Z'
                                            stroke='#CBD9F9'
                                            strokeWidth='1.6'
                                            strokeLinecap='round'
                                            strokeLinejoin='round'
                                        />
                                    </g>
                                </svg>
                                {t('BackToMap')}
                            </button>
                        </Link>
                    </div>
                    {/* <FullProdSlider
                        list={productsList}
                        link='/catalog'
                        page='products'
                        type='to-catalog'
                        headSlider={headSliderList} /> */}
                    <CardSlider
                        list={productsList}
                        headSlider={headSliderList}
                    />
                </div>
                {animalTypes && <MainSliderChapters list={animalTypes} />}
                <div className='container'>
                    <div className='main-products__about'>
                        <MainAbout item={cardItem} />
                    </div>
                    <div className='main-products__order'>
                        <MainOrder
                            item={{
                                tag: t("forCustomers"),
                                title: t("customOrder"),
                                text: [t("customOrderText"), t("customOrderText1")]
                            }}
                            btnContent={'Отправить заявку'}
                            link1={'/'}
                        />
                    </div>
                </div>
                <div className='container'>
                    <ForPartners title={true} />
                    <div className='news__section'>
                        <h2 className='main__section-title'>{t('news')}</h2>
                        <Link
                            href='/news'
                            className='useful-materials__link'
                        >
                            <p>{t('watchAll')}</p>
                            <svg
                                width='20'
                                height='20'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                    stroke='#83A3EB'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                />
                            </svg>
                        </Link>
                        <NewsBanner />
                    </div>
                </div>
            </div>
            {allMaterials && (
                <div className='products-materials__carousel'>
                    <div className='useful-materials__carousel'>
                        <div className='container'>
                            <div className='useful-materials__title'>{t('usefulMaterialsTitle')}</div>
                            <Link
                                className='useful-materials__link up'
                                href='/useful-materials'
                            >
                                <p>{t("watchAll")}</p>
                                <svg
                                    width='20'
                                    height='20'
                                    viewBox='0 0 20 20'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                        stroke='#83A3EB'
                                        strokeWidth='2'
                                        strokeLinecap='round'
                                    />
                                </svg>
                            </Link>
                        </div>
                        <div className='useful-materials__slider-limiter'>
                            <UsefulMatSlider
                                scroll={605}
                                list={allMaterials?.slice(0, allMaterials.length / 2)}
                            />
                        </div>
                        <div className='useful-materials__slider-limiter'>
                            <UsefulMatSlider
                                scroll={511}
                                list={allMaterials?.slice(allMaterials.length / 2)}
                            />
                        </div>
                    </div>
                    <div className='container'>
                        <CategoriesSlider
                            page='products'
                            list={allMaterials}
                        />
                        <Link
                            className='useful-materials__link under'
                            href='/useful-materials'
                        >
                            <p>Смотреть все</p>
                            <svg
                                width='20'
                                height='20'
                                viewBox='0 0 20 20'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    d='M9 15L12.9409 10.5664C12.9746 10.5285 12.9746 10.4715 12.9409 10.4336L9 6'
                                    stroke='#83A3EB'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                />
                            </svg>
                        </Link>
                    </div>
                </div>
            )}
            {/* <div className="container"> */}
            <Footer />
            {/* </div> */}
        </main>
    )
}

export default ProductsModule
